import { Component } from '@angular/core';
import { MatIconButton } from '@angular/material/button';
import { MatCard } from '@angular/material/card';
import { VulcanIconComponent } from '@eagle-i/vulcan-component-library';
import domtoimage from 'dom-to-image';
import JSZip from 'jszip';
import { BaseStateReportWidget } from '../base-state-report-widget';

@Component({
  selector: 'tgrid-cost-outage-residential-cost-widget',
  standalone: true,
  imports: [MatCard, MatIconButton, VulcanIconComponent],
  templateUrl: './cost-outage-residential-cost-widget.component.html',
  styleUrl: './cost-outage-residential-cost-widget.component.scss',
})
export class CostOutageResidentialCostWidgetComponent extends BaseStateReportWidget {
  protected async export(): Promise<void> {
    const container = this.exportContent()?.nativeElement;
    if (!container) return;

    // --- TXT ---
    const content = container.innerText;

    // --- PNG ---
    const dataUrl = await domtoimage.toPng(container, {
      bgcolor: '#ffffff',
      style: {
        padding: '20px',
      },
      filter: (node) => !(node instanceof HTMLElement && node.hasAttribute('data-html2canvas-ignore')),
    });
    const base64 = dataUrl.split(',')[1];

    // --- Zip ---
    const zip = new JSZip();
    zip.file('cost_outage_residential_cost.txt', content);
    zip.file('cost_outage_residential_cost.png', base64, { base64: true });

    const zipBlob = await zip.generateAsync({ type: 'blob' });

    const pngAnchor = document.createElement('a');
    pngAnchor.href = URL.createObjectURL(zipBlob);
    pngAnchor.download = 'cost_outage_residential_cost.zip';
    pngAnchor.click();
  }
}
